import React, { useState } from "react";
import useStyles from "./RejectDialog.css";
import translation from "../../../../i18n/i18.json";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormLabel,
  TextField,
  Grid,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { AlertDialogState } from "../../../../reducers/components/AlertDialogReducer";
import { RootState } from "../../../../reducers/index";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import AllActions from "../../../../actions";
import { ApprovalStatusData } from "../../../../models/Approval/ApprovalStatusData";
import { ResponseObject } from "../../../../models/ResponseObject";
import {
  InforDisplyaDuration,
  ResponseObjectType,
  FieldsLengthConstants
} from "../../../../constants/AppConstants";
import { RequestService } from "../../../../services/RequestService";

interface RejectDialogProps {
  open: boolean;
  title: string;
  message: string;
  btnOnetext: string;
  btnTwotext: string;
  onRejectConfirm: any;
  onRejectCancel: any;
  handleClose: any;
  dataToReject: ApprovalStatusData;
}

export default function RejectDialog(props: RejectDialogProps) {
  const classes = useStyles();
  const {
    open,
    title,
    message,
    btnOnetext,
    btnTwotext,
    onRejectConfirm,
    onRejectCancel,
    handleClose,
    dataToReject,
  } = props;

  const [isError, setIsError] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const dispatch = useDispatch();

  const prepareForRequest = () => {
    dispatch(AllActions.backDropActions.openBackDrop());
  };

  const compeleteRequest = (
    success: boolean,
    message?: string,
    duration?: number
  ) => {
    dispatch(AllActions.backDropActions.closeBackDrop());
    if (message) {
      let messageduration = duration ? duration : InforDisplyaDuration.common;
      if (success) {
        dispatch(
          AllActions.infoActions.openInforSuccess(message, messageduration!)
        );
      } else {
        dispatch(
          AllActions.infoActions.openInforError(message, messageduration!)
        );
      }
    }
  };

  const handleConfirm = (e: any, rejectReason: string) => {
    if (rejectReason && rejectReason !== "") {
      //onFirtButtonClick(rejectReason);
      prepareForRequest();
      RequestService.SetApprovalStatus(
        {
          requestId: dataToReject?.requestId!,
          companyCountryCode: '',
          approvalStatusId: 2,
          approvalLevelId: dataToReject?.approvalLevelId!,
          reasonForRejection: rejectReason,
          isUrgentRequest: false,
          isCalloverCannotVerify: dataToReject?.isCalloverCannotVerify,
          isSendVerificationNotification: dataToReject?.isSendVerificationNotification,
          vcExtendedInputs: dataToReject.vcExtendedInputs,
          verifiedContactPersonName: dataToReject.verifiedContactPersonName,
          requestComment: dataToReject.requestComment,
          verifierDesignation: dataToReject.verifierDesignation,
          checkListItems: [],
          vendorTypeCode:"",
           isTemporaryApproval:false,
           temporaryApprovalNoOfDays:""
        },
        function (approvalRespone: ResponseObject) {
          if (
            approvalRespone &&
            (approvalRespone.resposeObjectType ===
              ResponseObjectType.SAPError ||
              approvalRespone.resposeObjectType === ResponseObjectType.Error)
          ) {
            compeleteRequest(false, approvalRespone.message);
          } else if (
            approvalRespone &&
            approvalRespone.resposeObjectType === ResponseObjectType.SAPSuccess
          ) {
            compeleteRequest(
              true,
              approvalRespone.result +
                translation.rejectpopup_vendor_request_vendorcreatereject,
              InforDisplyaDuration.approvalStatus
            );
          } else {
            compeleteRequest(
              true,
              translation.rejectpopup_vendor_request_rejectsucess
            );
            onRejectConfirm(approvalRespone.result);
          }
          // compeleteRequest(true);
          // onRejectConfirm(approvalLevelId);
        },
        function (error: Error) {
          console.log(error);
          compeleteRequest(
            false,
            translation.rejectpopup_vendor_request_reject_err
          );
        }
      );
    } else {
      setIsError(true);
    }
  };

  const handleChange = (e: any) => {
    setRejectReason(e.target.value);
  };

  const handleExit = (e: any) => {
    setRejectReason("");
  };

  return (
    <div>
      <Dialog
        className={classes.popUpOuter}
        open={open}
        onExit={handleExit}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className={classes.popUpHeader} id="alert-dialog-title">
          {dataToReject?.isCalloverCannotVerify
            ? translation.callOverVerification_title_cannotverify
            : title}
        </DialogTitle>
        <DialogContent className={classes.NoPopWrapper}>
          {/* <DialogContentText id="alert-dialog-description"> */}
          <div style={{ fontWeight: "bold", margin: "10px 0 15px 0" }}>
            {dataToReject?.isCalloverCannotVerify
              ? translation.callOverVerification_message_cannotverify
              : message}
            {/* </DialogContentText> */}
            {/* <DialogContentText id="alert-dialog-description"> */}
          </div>
          <Grid className={classes.popdataRow}>
            <span
              className={classes.popUpLBL}
              style={{ margin: "12px 0px 10px", float: "left" }}
            >
              {dataToReject?.isCalloverCannotVerify
                ? translation.callOverVerification_reason_cannotverify
                : translation.dashboard_reject_reason}
            </span>
          </Grid>
          <Grid className={classes.popdataRow}>
            <TextField
              multiline
              rows={4}
              variant="outlined"
              value={rejectReason}
              error={isError}
              onChange={handleChange}
              inputProps={{ maxLength: FieldsLengthConstants.RejectReason }}
            ></TextField>
          </Grid>
          {/* </DialogContentText> */}
        </DialogContent>
        <DialogActions>
          <div style={{ float: "left", margin: "20px 10px 0px 0" }}>
            <div
              className={
                dataToReject?.isCalloverCannotVerify
                  ? classes.greenBtnWrapper
                  : classes.redBtnWrapper
              }
            >
              <Button
                onClick={(e) => handleConfirm(e, rejectReason)}
                color="primary"
              >
                <CheckCircleIcon></CheckCircleIcon>
                {dataToReject?.isCalloverCannotVerify
                  ? translation.callOverVerification_Btn_Txt_cannotverify
                  : btnOnetext}
              </Button>
            </div>
            <div className={classes.grayBtnWrapper}>
              <Button onClick={onRejectCancel} color="primary" autoFocus>
                {btnTwotext}
              </Button>
            </div>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
}
